import { cn } from "@gymflow/helpers";
import { cva, VariantProps } from "class-variance-authority";

const baseClasses =
  "block h-11 w-full flex-1 rounded-lg py-2.5 px-3.5 text-gray-900 placeholder:text-gray-400  sm:text-sm sm:leading-6 dark:bg-gray-950 dark:placeholder:text-gray-500 dark:!text-gray-50 border-0 bg-gray-0";
const defaultColors = "border border-gray-200 dark:!border-gray-800";


const inputVariants = cva(baseClasses, {
  variants: {
    state: {
      default: defaultColors,
      error: "border-error-200",
    },
  },
  defaultVariants: {
    state: "default",
  },
});

interface TextInputProps
  extends Omit<React.HTMLProps<HTMLInputElement>, "type">,
    VariantProps<typeof inputVariants> {
  type: "email" | "number" | "text" | "password" | "search" | "tel" | "url";
}

/**
 * @deprecated use atoms/base/Input instead
 */
export function TextInput({
  className,
  type,
  state,
  ...props
}: TextInputProps) {
  return (
    <input
      type={type}
      className={cn(inputVariants({ state }), className, {
        "bg-gray-100": props?.disabled,
      })}
      {...props}
    />
  );
}

TextInput.defaultProps = {
  type: "text",
};
